/** Shapes of the weather, calendar, notes and memory APIs, shared by server, web and mobile. */
/** Weather code → small glyph for cards. */
export function weatherGlyph(code) {
    if (code === 0 || code === 1)
        return '☀';
    if (code === 2)
        return '⛅';
    if (code === 3 || code === 45 || code === 48)
        return '☁';
    if ((code >= 71 && code <= 77) || code === 85 || code === 86)
        return '❄';
    if (code >= 95)
        return '⚡';
    return '☂';
}
//# sourceMappingURL=assistant.js.map